// Vitals section form field enum
export enum VitalsFormField {
  TEMPERATURE = 'vitals/temperature',
  PULSE = 'vitals/pulse',
  RESPIRATIONS = 'vitals/respirations',
  O2_SATURATION = 'vitals/o2-saturation',
  BLOOD_PRESSURE = 'vitals/blood-pressure',
  HEIGHT = 'vitals/height',
  BLOOD_SUGAR = 'vitals/blood-sugar',
  WEIGHT = 'vitals/weight'
}
